import axios from "axios";
import Config from "../../config";

const actionCriarChamado = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/chamados/criar`,
        data
    });
};

export default actionCriarChamado;
